import { useTheme } from '@/context/ThemeContext';

export default function Footer() {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className={`relative border-t transition-colors duration-500 ${isDark ? 'bg-[#0A0A0A] border-white/5' : 'bg-[#F5F5F7] border-black/5'}`}>
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16">
          <div className="md:col-span-1">
            <div className="mb-3">
              <img
                src="https://public.readdy.ai/ai/img_res/20b58411-1e66-4796-a013-aba2afbad94e.png"
                alt="AI Prime Systems Inc Logo"
                className={`h-16 w-auto object-contain ${isDark ? '' : 'brightness-0'}`}
              />
            </div>
            <p className={`font-grotesk text-sm mb-6 ${isDark ? 'text-white/35' : 'text-black/40'}`}>Precision Systems. Predictable Growth.</p>
            <div className="flex items-center gap-3">
              {['ri-linkedin-line', 'ri-twitter-x-line'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  rel="nofollow"
                  className={`w-8 h-8 flex items-center justify-center rounded-lg border transition-all cursor-pointer ${
                    isDark
                      ? 'border-white/10 text-white/40 hover:text-[#38D6D6] hover:border-[#38D6D6]/30'
                      : 'border-black/10 text-black/40 hover:text-[#38D6D6] hover:border-[#38D6D6]/30'
                  }`}
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <p className="font-grotesk text-xs text-[#38D6D6] uppercase tracking-widest mb-4">Navigation</p>
            <div className="flex flex-col gap-3">
              {[
                { label: 'Home', id: 'hero' },
                { label: 'Industries', id: 'industries' },
                { label: 'Results', id: 'case-studies' },
                { label: 'Contact', id: 'contact' },
              ].map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollTo(item.id)}
                  className={`text-left font-grotesk text-sm transition-colors cursor-pointer ${isDark ? 'text-white/50 hover:text-white' : 'text-black/50 hover:text-black'}`}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>

          <div>
            <p className="font-grotesk text-xs text-[#38D6D6] uppercase tracking-widest mb-4">Contact</p>
            <div className="flex flex-col gap-3">
              <a href="mailto:contact@aiprimesystems.com" rel="nofollow" className={`font-grotesk text-sm transition-colors ${isDark ? 'text-white/50 hover:text-white' : 'text-black/50 hover:text-black'}`}>
                contact@aiprimesystems.com
              </a>
              <a href="tel:+18005550100" rel="nofollow" className={`font-grotesk text-sm transition-colors ${isDark ? 'text-white/50 hover:text-white' : 'text-black/50 hover:text-black'}`}>
                +1 (800) 555-0100
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className={`border-t py-5 ${isDark ? 'border-white/5' : 'border-black/5'}`}>
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className={`font-grotesk text-xs ${isDark ? 'text-white/20' : 'text-black/25'}`}>
            &copy; {new Date().getFullYear()} AI Prime Systems Inc. All rights reserved.
          </p>
          <p className={`font-grotesk text-xs ${isDark ? 'text-white/15' : 'text-black/20'}`}>Built for operational reliability.</p>
        </div>
      </div>
    </footer>
  );
}
